var next = __webpack_require__.x;
__webpack_require__.x = () => {
	return Promise.all([630,3169,3520].map(__webpack_require__.e, __webpack_require__)).then(next);
};